import { ID } from '@models/base'
import { QueueModel } from '@models/queue'
import { QueueCounterModel } from '@models/queueCounter'

import { QueueNodeModel } from './queueNode'

export enum QueueNumberStatusEnum {
  Waiting = 'WAITING',
  Called = 'CALLED',
  Processing = 'PROCESSING',
  Skipped = 'SKIPPED',
  Completed = 'COMPLETED',
  Canceled = 'CANCELED',
  Missing = 'MISSING',
  Moved = 'MOVED',
  StandBy = 'STAND_BY',
}

export type PatientMedicineAllergyModel = {
  id: ID
  name?: string
  ucum?: string
}

export type QueueProcessModel = {
  id: ID // --> queue id
  name: string
  can_generate?: boolean
  is_default: boolean
  is_ending?: boolean
  allow_multiple_process: boolean
  preferred_next_queue?: QueueModel
  queue_counter?: QueueCounterModel
  waiting_nodes?: Array<QueueNodeModel>
  skipped_nodes?: Array<QueueNodeModel>
}

export enum QueueNodeCompleteActionEnum {
  TRANSFER = 'TRANSFER',
  END = 'END',
}
